import React, { useState } from "react";
import { CheckIcon, ChevronDownIcon, InfoIcon, TargetIcon } from "lucide-react";
import type { Volume } from "../data/volumes";
const VISIBLE = 6;
export function VolumeCard({
  volume
}: {
  volume: Volume;
}) {
  const [open, setOpen] = useState(false);
  const shown = open ? volume.items : volume.items.slice(0, VISIBLE);
  const hidden = volume.items.length - VISIBLE;
  const listId = `vol-${volume.numeral}-list`;
  return <article className="overflow-hidden rounded-3xl border border-line bg-white" data-id="element-329" data-mp="1usmorklkcdo9">
      <div className="flex items-center gap-4 bg-navy px-5 py-5 sm:px-8" data-id="element-330" data-mp="1pvmm7jnx9t1w">
        <span className="grid h-14 w-14 shrink-0 place-items-center rounded-xl border border-gold/40 font-serif text-2xl font-bold text-gold-light" data-id="element-331" data-mp="1l2tdkkpc20kj">
          {volume.numeral}
        </span>
        <div data-id="element-332" data-mp="2dkfl9ozuch0q">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-gold-light" data-id="element-333" data-mp="2dkxnd296ppgk">Volume {volume.numeral}</p>
          <h3 className="mt-1 font-serif text-xl font-bold leading-tight text-white sm:text-2xl" data-id="element-334" data-mp="28se1zj499q17">{volume.title}</h3>
        </div>
      </div>

      <div className="px-5 py-6 sm:px-8 sm:py-8" data-id="element-335" data-mp="3cb3smifj8u3h">
        <p className="font-serif text-xl italic leading-snug text-navy" data-id="element-336" data-mp="3c9sdjmgmzzx2">{volume.tagline}</p>
        <div className="mt-4 space-y-3 text-[15px] leading-relaxed text-muted sm:text-base" data-id="element-337" data-mp="2xl60xsie9m9j">
          {volume.intro.map(p => <p key={p} data-id="element-338" data-mp="32jh63pxqv8lf">{p}</p>)}
        </div>

        <p className="mt-6 text-xs font-bold uppercase tracking-[0.14em] text-gold-dark" data-id="element-339" data-mp="2ol9elxjh8zhn">{volume.listLabel}:</p>
        <ul id={listId} className="mt-3 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-340" data-mp="2tlnh702b7h8a">
          {shown.map(item => <li key={item} className="flex gap-2.5 text-[15px] leading-snug text-ink" data-id="element-341" data-mp="2eowd4dhoxhcc">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-342" data-mp="2jn7o4rjq1xw5" />
              <span data-id="element-343" data-mp="cwhybnag0t05">{item}</span>
            </li>)}
        </ul>
        {hidden > 0 && <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open} aria-controls={listId} className="mt-4 inline-flex items-center gap-1.5 rounded-lg text-sm font-bold text-navy underline-offset-4 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-344" data-mp="hujh073yiqb3">
            {open ? "Show less" : `See ${hidden} more inside`}
            <ChevronDownIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${open ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-345" data-mp="z4dx6b2aizu5" />
          </button>}

        <div className="mt-6 flex gap-3 rounded-2xl bg-gold-soft p-4" data-id="element-346" data-mp="pec7jeuah9d4">
          <TargetIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-347" data-mp="pchjvsrmv35c" />
          <p className="text-[15px] font-semibold leading-snug text-ink" data-id="element-348" data-mp="lawdmq9ltn44">
            <span className="text-gold-dark" data-id="element-349" data-mp="1hvokki8t4uha">The goal:</span> {volume.goal}
          </p>
        </div>

        {volume.note && <p className="mt-4 flex gap-2 text-[13px] leading-relaxed text-muted" data-id="element-350" data-mp="1d2274nutkmkf">
            <InfoIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-351" data-mp="2vsr92ycfhcjz" />
            {volume.note}
          </p>}
      </div>
    </article>;
}